import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { QRCodeComponent } from 'angularx-qrcode';

@Component({
    selector: 'warema-qr-code',
    imports: [QRCodeComponent],
    templateUrl: './qr-code.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class QrCodeComponent {
    public readonly data = input.required<string>();
    public readonly width = input.required<number>();
}
